





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import InputSearch from "../../search/input-search.vue";
import { routeInfo } from "@/config/host.config";
import axios from "@/api/AuthAPI/auth-request-api";

import { IRouteCity } from "@/@types/routeInfo/route-info";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

@Component({
  components: { InputSearch },
})
export default class VSelectDropdown extends Vue {
  @Prop({ type: Array, default: [] }) citys!: string[];
  search = "";
  cityList: IRouteCity[] = [];

  show = false;

  addCity(city: IRouteCity): void {
    this.$emit("addCity", city);
  }

  @Watch("search")
  filteredCitys(): IRouteCity[] {
    if (this.cityList.length > 0) {
      return this.cityList.filter((item) => {
        if (item && item.name) {
          const name = this.$getLocale(item.name);
          if (name) {
            return name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
          }
        }
      });
    }
    return [];
  }

  async getcityList(): Promise<IRouteCity[]> {
    const url: string = routeInfo.citys;
    const config: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise((res, rej) => {
      axios
        .get(url, config)
        .then((routes: AxiosResponse) => {
          if (routes.status === 200) {
            res(routes.data);
          }
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  startCreateСityList(): void {
    this.getcityList()
      .then((citys: IRouteCity[]) => {
        this.cityList = citys;
        if (citys.length > 0) {
          this.show = false;
          this.$nextTick(() => {
            this.show = true;

            for (const c of this.citys) {
              for (const item of citys) {
                if (c === item._id) {
                  this.addCity(item);
                }
              }
            }
          });
        } else {
          this.show = false;
        }
      })
      .catch(() => {
        this.show = false;
      });
  }

  mounted(): void {
    this.startCreateСityList();
  }
}
